/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Transcript_LabelInputs */



/**
* | output |
* | --- |
* | "Live captioning transcript" |
*
* @param {Live_Caption_Transcript_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_transcript_label = /** @type {((inputs?: Live_Caption_Transcript_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Transcript_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcription du sous-titrage en direct")
	if (locale === "de") return /** @type {LocalizedString} */ ("Live-Untertitelungs-Transkript")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trascrizione dei sottotitoli in diretta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текст субтитров в реальном времени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transcripción con subtítulos en directo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("实时字幕文字稿")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ライブキャプションの文字起こし")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइव कैप्शनिंग ट्रांसक्रिप्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("transcrição da legenda ao vivo")
	return /** @type {LocalizedString} */ ("Live captioning transcript")
});